import AnyScale from './any-scale.view';

export default AnyScale;
